import * as React from 'react';
import { RefContextProvider, useRefContext } from '../ref-context';
export var RefProviderRoot = function (_a) {
    var children = _a.children;
    var refTargets = React.useRef({});
    /**
     * Registers a ref for a given target that can be used anywhere
     * else down the tree.
     * @param name
     * @returns ref - The ref for the given target, or null if it's invalid
     */
    var registerTarget = function (name) {
        if (!name) {
            return { current: null };
        }
        // Returns the existing ref
        if (refTargets.current[name]) {
            return refTargets.current[name];
        }
        // Create a new ref for this target
        var ref = React.createRef();
        refTargets.current[name] = ref;
        return ref;
    };
    /**
     * Retrieve the refs for all targets in the list, if a ref
     * doesn't exist yet, we create one.
     * @param names - list of target names
     * @returns refs - list of refs for the input targets
     */
    var getTargets = function (names) {
        var targets = names.reduce(function (acc, name) {
            if (refTargets.current[name]) {
                acc[name] = refTargets.current[name];
                return acc;
            }
            var ref = React.createRef();
            refTargets.current[name] = ref;
            acc[name] = ref;
            return acc;
        }, {});
        return targets;
    };
    return React.createElement(RefContextProvider, { value: { registerTarget: registerTarget, getTargets: getTargets } }, children);
};
export var RefTarget = function (_a) {
    var children = _a.children, name = _a.name, className = _a.className, dataStid = _a.dataStid, tabIndex = _a.tabIndex, _b = _a.tag, Tag = _b === void 0 ? 'div' : _b;
    var registerTarget = useRefContext().registerTarget;
    if (!name) {
        return React.createElement(React.Fragment, null, children);
    }
    var ref = registerTarget(name);
    return (React.createElement(Tag, { id: name, ref: ref, className: className, "data-stid": dataStid, tabIndex: tabIndex }, children));
};
//# sourceMappingURL=ref-components.js.map